import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import BackButton from "../../../../../components/UiKit/Buttons/BackButton/BackButton";
import Input from "../../../../../components/UiKit/Input/Input";
import Select from "../../../../../components/UiKit/Select/Select";
import { useEffect } from "react";
import stl from "./MyInfoComponent.module.css";
import { useTranslation } from "@i18n";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import useValidate from "@hooks/useValidate";
import ProfileLayOut from "@/pages/user/ProfileComponents/ProfileLayOut/ProfileLayout";
import useHelpers from "@hooks/useHelpers";
import { useAuthActions, useSession } from "@/_MiniApps/auth/AuthContext";
import useButtonLoading from "@hooks/useButtonLoading";
import useAlertsToaster from "@hooks/useAlertsToaster";
import InputPhoneNumber from "@componentsShared/InputPhoneNumber/InputPhoneNumber";
var MyInfoComponent = function MyInfoComponent(_ref) {
  var cities = _ref.cities;
  var buttonLoading = useButtonLoading();
  var _useSession = useSession(),
    user = _useSession.user;
  var _useTranslation = useTranslation(["web_common", "web_user_account"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useAuthActions = useAuthActions(),
    remote_updateUserCityProfile = _useAuthActions.remote_updateUserCityProfile,
    remote_updateUserNameProfile = _useAuthActions.remote_updateUserNameProfile;
  var _useState = useState(user === null || user === void 0 ? void 0 : user.city_id),
    cityId = _useState[0],
    setCityId = _useState[1];
  var _useState2 = useState(""),
    name = _useState2[0],
    setName = _useState2[1];
  var _useState3 = useState(""),
    nameError = _useState3[0],
    setNameError = _useState3[1];
  var _useState4 = useState(false),
    showSubmitBtn = _useState4[0],
    setShowSubmitBtn = _useState4[1];
  var _useAlertsToaster = useAlertsToaster(),
    successToast = _useAlertsToaster.successToast;
  var _useValidate = useValidate(),
    validateName = _useValidate.validateName;
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var nameError;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            nameError = validateName(name);
            if (!nameError) {
              _context.n = 1;
              break;
            }
            return _context.a(2, setNameError(nameError));
          case 1:
            _context.n = 2;
            return remote_updateUserNameProfile(name);
          case 2:
            successToast(t("name_saved_successfully", {
              ns: "web_user_account"
            }));
            setShowSubmitBtn(false);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleSelectOnChange = function handleSelectOnChange(e) {
    var value = e.target.value;
    setCityId(value);
  };
  useEffect(function () {
    if (cityId !== (user === null || user === void 0 ? void 0 : user.city_id)) {
      remote_updateUserCityProfile(cityId).then(function () {
        successToast(t("data_saved_successfully", {
          ns: "web_user_account"
        }));
        navigateTo("/user/account/my-info");
      });
    }
  }, [cityId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProfileLayOut, {
    title: t("my_information", {
      ns: "web_user_account"
    }),
    wideContainer: true,
    className: "m-hide",
    userInfo: true
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.BackButton
  }, /*#__PURE__*/React.createElement(BackButton, {
    type: "submit",
    onClick: function onClick() {
      return navigateTo("/user/account");
    }
  }, /*#__PURE__*/React.createElement("span", null, t("back", {
    ns: "web_common"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: stl.subContainer
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: stl.flex
  }, /*#__PURE__*/React.createElement(Input, {
    name: "full_name",
    type: "text",
    value: user !== null && user !== void 0 && user.full_name ? user === null || user === void 0 ? void 0 : user.full_name : name,
    disabled: !!(user !== null && user !== void 0 && user.full_name),
    onChange: function onChange(e) {
      setName(e.target.value);
      setNameError("");
      setShowSubmitBtn(true);
    },
    label: t("full_name", {
      ns: "web_user_account"
    }),
    className: "".concat(user !== null && user !== void 0 && user.full_name ? stl.disabledInput : "", " ").concat(stl.input),
    error: nameError
  }), (user === null || user === void 0 ? void 0 : user.full_name) && /*#__PURE__*/React.createElement("span", {
    className: stl.edit,
    onClick: function onClick() {
      return navigateTo("/user/account/my-info/edit-name");
    }
  }, t("edit", {
    ns: "web_user_account"
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.flex
  }, /*#__PURE__*/React.createElement(InputPhoneNumber, {
    disabled: true,
    defaultValue: user === null || user === void 0 ? void 0 : user.phone_number,
    onChange: function onChange(value) {},
    errorLabel: ""
  }), /*#__PURE__*/React.createElement("span", {
    className: stl.edit,
    onClick: function onClick() {
      return navigateTo("/user/account/my-info/edit-mobile");
    }
  }, t("edit", {
    ns: "web_user_account"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Select, {
    name: "city_id",
    label: t("city", {
      ns: "web_user_account"
    }),
    value: user === null || user === void 0 ? void 0 : user.city_id,
    onChange: handleSelectOnChange,
    className: stl.select
  }, /*#__PURE__*/React.createElement("option", {
    value: "0",
    disabled: true
  }), !(user !== null && user !== void 0 && user.city_id) && /*#__PURE__*/React.createElement("option", {
    value: 0,
    disabled: true,
    selected: true
  }), cities.filter(function (item) {
    return item === null || item === void 0 ? void 0 : item.id;
  }).map(function (item, idx) {
    return /*#__PURE__*/React.createElement("option", {
      value: item.id,
      key: idx
    }, item.name);
  }))), showSubmitBtn && /*#__PURE__*/React.createElement(SubmitButton, {
    onClick: handleSubmit,
    className: stl.btn,
    loading: buttonLoading
  }, t("save", {
    ns: "web_user_account"
  })))));
};
export default MyInfoComponent;